import React, { useEffect, useState, useContext, useLayoutEffect, useCallback } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'

import icocopyadd from '../img/ico-copyadd.png'
import icodelete from '../img/ico-delete.png'
import icoedit from '../img/ico-edit.png'

import $ from 'jquery';
import { AppColors } from '../css/AppColors';
import { apiRequest } from '../utils/apiCalls';
import { Modal, Button, Form } from 'react-bootstrap';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { FaClipboardList, FaPencilAlt, FaTrash } from 'react-icons/fa'
import { Link, useLocation } from 'react-router-dom';



const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}


const ManagePromotion = () => {

    const forceUpdate = useForceUpdate();
    var location = useLocation();


    const [promotions, setPromotions] = useState([])
    const [loading, setLoading] = useState(false)

    const [delPromId, setDelPromId] = useState('')
    const [delModal, setDelModal] = useState(false)

    const { state, setProductsGlobal } = useContext(Context)
    const [prod, setProd] = useState(state.products ? state.products : [])
    const [p_id, setP_id] = useState(location?.state?.p_id ? location.state.p_id : '')

    const [prodData, setProdData] = useState(location?.state ? location.state : null);



    function getPromotions(id) {
        var pId;
        if (id) pId = id
        else pId = p_id
        console.log('location.state')
        console.log(location?.state)

        setLoading(true)
        apiRequest({ p_id: pId }, 'viewPromotions')
            .then(data => {
                console.log(data)
                setLoading(false)
                if (data.status == '1') {
                    setPromotions(data.data)
                    forceUpdate()
                }
                else {
                    setPromotions([])
                    forceUpdate()
                }
            })
            .catch(err => {
                setLoading(false)
                alert("Internet Error")
            })
    }


    function delProm() {

        const reqObj = {
            prom_id: delPromId,
            p_id: p_id
        }
        console.log(reqObj)
        setLoading(true)
        apiRequest(reqObj, 'delPromotion')
            .then(data => {
                console.log(data)
                if (data.status == '1') {
                    if (data.data) {
                        setLoading(false)
                        setPromotions(data.data)
                        // alert(data.msg)
                    }
                    else {
                        setLoading(false)
                        alert(data.msg)
                    }
                }
                else {
                    setLoading(false)
                    alert(data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                alert('Internet Error')
            })


    }

    function getProducts() {

        setLoading(true)
        apiRequest({ st_id: state.storeData.st_id }, 'viewprod')
            .then(data => {

                if (data.status == '1') {
                    setProd(data.data)
                    setProductsGlobal(data.data)
                    setLoading(false)
                }
                else {
                    // alert(data.error)
                    setLoading(false)
                }
            })
            .catch(err => {
                setLoading(false)
                alert('Network error')
                console.log(err)
            })
    }



    useEffect(() => {
        $(document).ready(function () {
            $('#dataTable').DataTable();
        });
    }, [loading])


    useEffect(() => {
        if (!state.products.length) {
            getProducts()
        }
        console.log('location = ')
        if (location?.state?.p_id) {
            getPromotions(location.state?.p_id);
            const arr = prod.filter(data => data.p_id == location.state.p_id);
            console.log('arr = ')
            console.log(arr)
            setProdData(arr[0]);
            forceUpdate();
        }



    }, [])
    return (

        <div id="page-top">
            <div id="wrapper" >
                <Sidebar />



                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />

                        <Modal
                            show={delModal}
                            onHide={() => setDelModal(false)}
                        >
                            <Modal.Header>
                                <Modal.Title style={{ fontSize: 18, textAlign: 'center', alignSelf: 'center', fontFamily: 'PSBo' }} >Are you sure you want to delete this promotion?</Modal.Title>
                            </Modal.Header>
                            <Modal.Footer>
                                <Button
                                    style={{ fontFamily: 'PMe' }}
                                    variant="secondary" onClick={() => {
                                        setDelPromId('')
                                        setDelModal(false)
                                    }}>No</Button>
                                <Button
                                    style={{ fontFamily: 'PMe' }}
                                    variant="danger" onClick={() => {
                                        setDelModal(false)
                                        delProm()
                                    }}>Yes</Button>
                            </Modal.Footer>


                        </Modal>

                        <Modal
                            show={loading}
                        >

                            <Modal.Body class="text-center" >
                                <div
                                    class="text-center"
                                    class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                            </Modal.Body>

                        </Modal>
                        <div className="container-fluid" >
                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-gray-800">Manage Promotion</h1>
                            </div>
                            <div className="col-sm-6">
                                {/*  */}
                                <div className="editDetails" style={{ fontSize: 13 }} >Select Product</div>
                                <Form.Select
                                    className="editDetails" size="md"
                                    onChange={(v) => {
                                        let obj = v.target.value
                                        obj = JSON.parse(obj)
                                        setProdData(obj)
                                        setP_id(obj.p_id)
                                        getPromotions(obj.p_id)
                                        forceUpdate();

                                    }}
                                >
                                    {


                                        prod?.map((v, i) => {

                                            // if(v.p_id == p_id)  setProdData(v)

                                            return (
                                                <>

                                                    {
                                                        i == 0 &&
                                                        <option selected disabled={true}>Select Product</option>
                                                    }

                                                    {/* // location?.state?.p_id == v.p_id ? <></> : */}
                                                    <option
                                                        selected={p_id == v.p_id ? true : false}
                                                        value={JSON.stringify(v)}
                                                    >{v.p_name} </option>
                                                    {/* } */}
                                                </>
                                            )
                                        })
                                    }
                                </Form.Select>
                                {/* </div> */}
                                {/*  */}
                                {/* <input
                                    type="text"
                                    value={location?.state?.p_name}
                                    disabled={true}
                                    className="form-control form-control-user"
                                    placeholder={location?.state?.prod_name}
                                />
                                <br /> */}
                            </div>

                            {
                                !loading && promotions.length ?

                                    <div className="card shadow mb-4" style={{ width: "100%" }} >


                                        <div className="card-body">
                                            <div className="table-responsive">
                                                {/* table class="table table-bordered dt-responsive" id="dataTable" width="100%" cellspacing="0" */}

                                                <table
                                                    id="dataTable"
                                                    className="table table-striped table-bordered dt-responsive"
                                                    style={{ width: "100%" }}
                                                    cellSpacing={0}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th className="tRow" >Promotion</th>
                                                            <th className="tRow" >MSRP</th>
                                                            <th className="tRow">Promotion Amount</th>
                                                            <th className="tRow">Start date</th>
                                                            <th className="tRow">End date</th>
                                                            <th className="tRow" style={{ alignSelf: 'center', textAlign: 'center' }} >Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            promotions?.map((v) => {
                                                                return (
                                                                    <tr>
                                                                        <td className="tData">
                                                                            <nobr>{v.prom_name}</nobr>
                                                                        </td>
                                                                        <td className="tData">
                                                                            <nobr>{location?.state?.p_MSRP ? location.state.p_MSRP : prodData.p_MSRP}</nobr>
                                                                        </td>
                                                                        <td className="tData">
                                                                            <nobr> {v.prom_type == 'fixed' && "$"}{v.prom_amount}{v.prom_type == 'percent' && "%"} </nobr>
                                                                        </td>
                                                                        <td className="tData">
                                                                            <nobr>{v.prom_start_date}</nobr>
                                                                        </td>
                                                                        <td className="tData">
                                                                            <nobr>{v.prom_end_date}</nobr>
                                                                        </td>

                                                                        <td style={{ textAlign: 'center' }}>

                                                                            {/* <td className="tData"> */}
                                                                            <Link
                                                                                to={{
                                                                                    pathname: "/addPromotion",
                                                                                    state: prodData ? prodData : location?.state ? location?.state : null
                                                                                }}
                                                                                className="tData btn" style={{ color: 'rgba(0,0,0,0.7)', fontSize: 15, fontFamily: 'RMe' }} >
                                                                                <img src={icocopyadd} />
                                                                            </Link>

                                                                            {/* </td> */}
                                                                            <Link to=
                                                                                {{
                                                                                    pathname: '/viewPromotion',
                                                                                    state: {
                                                                                        data: v,
                                                                                        prodData: prodData ? prodData : location?.state ? location?.state : null
                                                                                    }
                                                                                }}
                                                                                className="btn" style={{ backgroundColor: '#54C2BB' }} >
                                                                                <FaClipboardList color="white" />
                                                                            </Link>{" "}

                                                                            <Link


                                                                                to={{
                                                                                    pathname: '/editPromotion',
                                                                                    state: {
                                                                                        data: v,
                                                                                        prodData: prodData
                                                                                    }

                                                                                }}
                                                                                className="btn" style={{ backgroundColor: '#54C2BB' }} >
                                                                                <FaPencilAlt color="white" />
                                                                            </Link>{" "}
                                                                            <Button
                                                                                onClick={() => {

                                                                                    setDelPromId(v.prom_id)
                                                                                    setDelModal(true)
                                                                                }} className="btn btn-danger del_product" id>
                                                                                <FaTrash color="white" />
                                                                            </Button>
                                                                        </td>

                                                                        {/* <td className="tData">
                                                                            <Link to=
                                                                                {{
                                                                                    pathname: '/editPrescription',
                                                                                    state: v
                                                                                }}
                                                                                className="tData" style={{ color: 'rgba(0,0,0,0.7)', fontSize: 15, fontFamily: 'RMe' }} >
                                                                                <img src={icoedit} />
                                                                            </Link>
                                                                        </td>
                                                                        <td className="tData">
                                                                            <Button
                                                                                variant="outline-none"
                                                                                onClick={() => {
                                                                                    
                                                                                }}
                                                                            >
                                                                                <img src={icodelete} />
                                                                            </Button>

                                                                        </td> */}
                                                                    </tr>
                                                                )
                                                            })
                                                        }


                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>


                                    </div>
                                    : !loading && p_id && <div>
                                        <div className="d-sm  align-items-center justify-content-center mb-4" style={{ textAlign: 'center' }}>
                                            <h3 className="h5 mb-0 text-gray-800" style={{ color: 'grey', fontSize: 18 }}>No promotion added yet</h3>
                                            <br></br>
                                            <Button
                                                style={{ color: 'white', backgroundColor: AppColors.primary, borderWidth: 0, fontFamily: 'RBo' }}
                                            >
                                                <Link
                                                    style={{ color: 'white', textDecorationLine: 'none' }}
                                                    to={{
                                                        pathname: "/addPromotion",
                                                        state: location?.state ? location?.state : prodData
                                                    }}>
                                                    Click to add
                                                </Link>
                                            </Button>
                                        </div>

                                    </div>
                            }



                        </div>
                    </div>
                </div>
            </div >
        </div >

    )
}

export default ManagePromotion
